<template>
  <div
    class="screening-progress-card-actions"
    :class="{ stopping: shouldStopScreening }"
  >
    <!-- Stopping Criteria has been met -->
    <template v-if="shouldStopScreening">
      <div class="stopping-caption">
        <v-icon class="material-icons-outlined" color="grey">
          info
        </v-icon>
        You may stop screening as it is unlikely any relevant
        references remain.
      </div>

      <!-- Stop screening button (handles the modal + API call internally) -->
      <stop-screening-button
        :review="review"
        :current-researcher="currentResearcher"
      />
    </template>

    <!-- Stopping Criteria has not been met -->
    <template v-else>
      <action-button
        v-if="hasConflicts"
        class="mr-3"
        @click="redirectToConflictsTab"
      >
        Resolve Conflicts
      </action-button>
      <action-button color="primary" @click="redirectToScreenTab">
        Screen References
      </action-button>
    </template>
  </div>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import StopScreeningButton from '../Common/StopScreeningButton';
import { Review, Researcher } from '@/models';

export default {
  name: 'ScreeningProgressCardActions',
  components: {
    ActionButton,
    StopScreeningButton,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
    currentResearcher: {
      type: Researcher,
      required: true,
    },
  },
  computed: {
    shouldStopScreening() {
      return this.review.shouldStopScreening();
    },
    hasConflicts() {
      return (
        this.review.screeningProgressSummary.conflictedScreenCount > 0
      );
    },
  },
  methods: {
    redirectToScreenTab() {
      this.$router.push(`/review/${this.review.id}/screening/screen`);
    },
    redirectToConflictsTab() {
      this.$router.push(
        `/review/${this.review.id}/screening/screen#conflicted`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

.screening-progress-card-actions {
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: flex-end;

  &.stopping {
    justify-content: space-between;
  }

  color: map-get($grey, 'base');

  .stopping-caption {
    font-size: 14px;
    font-weight: 500;
  }
}
</style>
